module.exports = __webpack_public_path__ + "img/envelope5.c16a340d.jpg";